import './styles/main.sass'

import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App'

import '@/plugins'

Vue.config.productionTip = false

/* eslint-disable no-new */
const ಠ_ಠ = new Vue({
  el: '#app',
  store,
  router,
  ...App
})

document.addEventListener('DOMContentLoaded', function () {
  ಠ_ಠ.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js